(function () {
  "use strict";

  angular.module("virtualFairs")
    .controller("VirtualFairEventContactsController", VirtualFairEventContactsController);

    VirtualFairEventContactsController.$inject = ["VirtualFairService", "CountriesNewService", "virtualFairs", "semesters", "$timeout"];

  function VirtualFairEventContactsController(VirtualFairService, CountriesNewService, virtualFairs, semesters, $timeout) {
    
    var vm = this;
    vm.flag = false;
    vm.virtualFairSelected = [];
    vm.getByFilter = getByFilter;
    vm.getByFilterCsv = getByFilterCsv;
    vm.getVirtualFairsBySemester = getVirtualFairsBySemester;
    vm.getCountries = getCountries;
    vm.getRegions = getRegions;
    vm.yesNo = [{id:0, name : 'No'},{id: 1, name : 'Yes'}];
    vm.semesterSelected = [];
    vm.countrySelected = [];
    vm.regionSelected = [];
    vm.onlyTSWEvents = [{id: -1, name : '--- All ---'}];

    function getByFilter() {
      vm.flag = false;
      let query = {};

      if(vm.virtualFairSelected.length > 0) {
        query['virtual_fair_id'] = JSON.stringify(vm.virtualFairSelected);
      }

      if(vm.onlyTSWEvents.id != -1) {
        query['fpp_event'] = vm.onlyTSWEvents.id;
      }

      if(vm.semesterSelected.length > 0) {
        query['semester'] = [];
        angular.forEach(vm.semesterSelected, function(value, key) {
            query['semester'].push(value);
        });
        query['semester'] = query['semester'].join();
      }

      if(vm.countrySelected.length > 0) {
        query['country_id'] = [];
        angular.forEach(vm.countrySelected, function(value, key) {
            query['country_id'].push(value);
        });
        query['country_id'] = query['country_id'].join();
      }

      if(vm.regionSelected.length > 0) {
        query['region_id'] = [];
        angular.forEach(vm.regionSelected, function(value, key) {
            query['region_id'].push(value);
        });
        query['region_id'] = query['region_id'].join();
      }

      VirtualFairService.eventContacts(query).then(function(response) {
        vm.flag = true;
        vm.eventContacts = response.data;
      });
    }

    function getVirtualFairsBySemester () {
      let query = {};
      if(vm.semesterSelected.length == 1) {
        query['semester'] = vm.semesterSelected[0];
      }
      VirtualFairService.getVirtualFairsBySemester(query).then(function(response) {
        vm.virtualFairs = response.data;
      });
    }

    function getCountries () {
      CountriesNewService.getCountries().then(function(response){
          vm.countries = response.data;
      });
    }

    function getRegions () {
      vm.regionSelected = [];
      if(vm.countrySelected.length == 1) {
        CountriesNewService.getRegions(vm.countrySelected[0]).then(function(response) {
            vm.regions = response.data;
        }).catch(function(err) {

        });
      }
    }

    function getByFilterCsv () {
      let query = {};

      if(vm.virtualFairSelected.length > 0) {
        query['virtual_fair_id'] = JSON.stringify(vm.virtualFairSelected);
      }

      if(vm.semesterSelected.length > 0) {
        query['semester'] = [];
        angular.forEach(vm.semesterSelected, function(value, key) {
            query['semester'].push(value);
        });
        query['semester'] = query['semester'].join();
      }

      if(vm.countrySelected.length > 0) {
        query['country_id'] = [];
        angular.forEach(vm.countrySelected, function(value, key) {
            query['country_id'].push(value);
        });
        query['country_id'] = query['country_id'].join();
      }

      if(vm.regionSelected.length > 0) {
        query['region_id'] = [];
        angular.forEach(vm.regionSelected, function(value, key) {
            query['region_id'].push(value);
        });
        query['region_id'] = query['region_id'].join();
      }
      VirtualFairService.eventContactsCsv(query).success(function(data) {
        var anchor = document.createElement("a");
        anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
        anchor.target = "_blank";
        anchor.download = `virtual_fair_event_contacts.csv`;
        document.body.appendChild(anchor);
        anchor.click();
        $timeout(function () {
          anchor.remove();
        }, 50);
      });
    }

    function activate() {
      vm.getCountries();

      vm.virtualFairs = virtualFairs;

      vm.semesters = semesters;
      vm.semesters.unshift({'semester': '--- All ---', 'start_at_datetime': ''});
    }
    
    activate();
  }
})();
